export const environment = {
    production: false,
    name: 'development',
    service_1:'https://www.pruebas-observatorio-mujer.unidadacin.co/madeja_backend_dev/api/v1/',
    domain: 'https://www.pruebas-observatorio-mujer.unidadacin.co',
    google_client_id:
        '405758850016-qu40u3jf966rjkt5jchti1olgnqr3rnd.apps.googleusercontent.com',
}
